import { FormItemTypes, IDictionary } from '@bimser/core';
import { IContainerLayout, IDesignerProps, IPropertyField } from '../../../entities/common';
import { ILayoutControlProperties } from '../entities/ILayoutControlProperties';
import Control from './Control';
import { Map } from 'immutable';
import { JSX } from 'react';

export default class LayoutControl extends Control {
	designerProps: IDesignerProps;
	layout: IContainerLayout;

	constructor() {
		super();

		this.layout = {
			visible: true,
			clientVisible: true,
			width: undefined
		};
	}

	__loadProperties(data: ILayoutControlProperties) {
		super.__loadProperties(data);
		this.__proxyChanged.designerProps = data.designerProps;
		this.__proxyChanged.layout = data.layout;
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			layout: this.layout
		};
	}

	__getPropertyFields(properties?: Map<string, any>): IPropertyField[] {
		const fields = super.__getPropertyFields();

		let items: IPropertyField[] = [
			{
				name: 'visible',
				type: 'boolean'
			},
			{
				name: 'clientVisible',
				type: 'boolean'
			}
		];

		if (this.controlType === FormItemTypes.EContainerTypes.Column) {
			items = [
				{
					name: 'width',
					type: 'string',
					hiddenOn: []
				},
				...items
			];
		}

		return [
			...fields,
			{
				name: 'layout',
				type: 'object',
				items
			}
		];
	}

	__render(children?: React.ReactNode): JSX.Element {
		return super.__render(children);
	}
}
